window.initElmoIframeResize = function (iframe) {
    if (!iframe || typeof window.iFrameResize !== 'function') {
        return;
    }

    window.iFrameResize(
        {
            heightCalculationMethod: 'max',
                   

            resizedCallback: function (messageData) {
                requestAnimationFrame(function () {
                    const elmoContainer = iframe.closest('.section-iframe__scroll');
                    const iframeScrollContainer = document.querySelector('#iframe-scroll-container');
                    const sectorContainer = document.querySelector('#sector-jobs-container');

                    if (!elmoContainer) {
                        return;
                    }
                    if (sectorContainer) {
                        const height = elmoContainer.getBoundingClientRect().height;
                        sectorContainer.style.height = `${height}px`;
                    }
                    if(iframeScrollContainer){
                        const height = elmoContainer.getBoundingClientRect().height;
                        iframeScrollContainer.style.height = `${height}px`;
                    }
                });
            }
        },
        iframe
    );
};

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-elmo-iframe]').forEach(function (iframe) {

        iframe.addEventListener('load', function () {
            iframe.style.display = 'block';
        });

        window.initElmoIframeResize(iframe);
    });
});